import { InputOption, KeyValue } from "../../shared/models/Input";

export interface DataForm {
	civilite: InputOption,
	nom: InputOption,
	prenom: InputOption,
	nomNaissance: InputOption,
	dateNaissance: InputOption,
	communeNaissance: InputOption,
	pays: InputOption,
	nationalite: InputOption,
	situation: InputOption,
	adresse: InputOption,
	complement: InputOption,
	codepostal: InputOption,
	commune: InputOption,
	secu: InputOption,
	crpcen: InputOption,
	telephoneFixe: InputOption,
	telephonePortable: InputOption,
	emailPerso: InputOption,
	emailPro: InputOption,
	mutuelle: InputOption,
	partPatronale: InputOption,
	partSalarial: InputOption,
	transport: InputOption,
	titreRestaurant: InputOption,
	typeMajoration: InputOption,
	modeReglement: InputOption,
	classification: InputOption,
	intitule: InputOption,
	dateEntree: InputOption,
	dateEntreeMetier: InputOption,
	heuresSemaine: InputOption,
	heuresSupSemaine: InputOption,
	heuresMois: InputOption,
	heuresSupMois: InputOption,
	salaire: InputOption,
	nombrePoint: InputOption,
	complementSalaire: InputOption,
	nature: InputOption,
	type: InputOption,
	regime: InputOption,
	divers: InputOption,
	cp: InputOption,
	cc: InputOption,
	bban: InputOption,
	bic: InputOption,
	titulaire: InputOption,
	domiciliation: InputOption,
	nomBanque: InputOption,
	dateFinCdd: InputOption,
	motifRecours: InputOption,
	salarieRemplace: InputOption
}

export const dataFormBase: DataForm = {
	civilite: {
		vmodel: "",
		label: "Civilité",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	nom: {
		vmodel: "",
		label: "Nom",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 50
	},
	prenom: {
		vmodel: "",
		label: "Prénom",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 50
	},
	nomNaissance: {
		vmodel: "",
		label: "Nom de naissance",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 30
	},
	dateNaissance: {
		vmodel: "",
		label: "Date de naissance",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: '1900-01-01',
		display: ''
	},
	communeNaissance: {
		vmodel: "",
		label: "Commune de naissance",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 50
	},
	pays: {
		vmodel: "",
		label: "Pays de naissance",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	nationalite: {
		vmodel: "",
		label: "Nationalité",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	situation: {
		vmodel: "",
		label: "Situation familiale",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	adresse: {
		vmodel: "",
		label: "Adresse",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 50
	},
	complement: {
		vmodel: "",
		label: "Complément d'adresse",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 50
	},
	codepostal: {
		vmodel: "",
		max: 5,
		label: "Code postal",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	commune: {
		vmodel: "",
		label: "Commune",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 50
	},
	secu: {
		vmodel: "",
		max: 15,
		label: "Numéro de sécurité sociale",
		trigger: false,
		required: true,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	crpcen: {
		vmodel: "",
		label: "Numéro de CRPCEN",
		trigger: false,
		error: false,
		max: 6,
		clear: false,
		reset: false,
		disabled: false
	},
	telephoneFixe: {
		vmodel: "",
		label: "Téléphone fixe",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 20
	},
	telephonePortable: {
		vmodel: "",
		label: "Téléphone portable",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 20
	},
	emailPerso: {
		vmodel: "",
		label: "Email perso",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 150
	},
	emailPro: {
		vmodel: "",
		label: "Email pro",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 150
	},
	mutuelle: {
		vmodel: "",
		label: "Mutuelle",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	partPatronale: {
		vmodel: "",
		label: "Part patronale",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	partSalarial: {
		vmodel: "",
		label: "Part salariale",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	transport: {
		vmodel: "",
		label: "Remboursement transport",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		maxValue: 9999.99
	},
	titreRestaurant: {
		vmodel: "",
		label: "Titres restaurant",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		maxValue: 9999.99
	},
	modeReglement: {
		vmodel: "",
		label: "Mode de règlement",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	classification: {
		vmodel: "",
		label: "Classification",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		height: 384
	},
	intitule: {
		vmodel: "",
		label: "Intitulé du poste",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 65
	},
	dateEntree: {
		vmodel: "",
		label: "Date d'entrée",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: '1900-01-01',
		display: ''
	},
	dateEntreeMetier: {
		vmodel: "",
		label: "Date d'entrée dans le métier",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		minDate: '1900-01-01',
		display: ''
	},
	heuresSemaine: {
		vmodel: "",
		label: "Heures par semaine",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	heuresSupSemaine: {
		vmodel: "",
		label: "Heures SUP par semaine",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	heuresMois: {
		vmodel: "",
		label: "Heures par mois",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	heuresSupMois: {
		vmodel: "",
		label: "Heures SUP par mois",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	salaire: {
		vmodel: "",
		label: "Salaire brut total mensuel",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	nombrePoint: {
		vmodel: "",
		label: "Nombre de points complémentaire",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	complementSalaire: {
		vmodel: "",
		label: "Complément de salaire",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	nature: {
		vmodel: "",
		label: "Nature du contrat",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	type: {
		vmodel: "",
		label: "Type de contrat",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	typeMajoration: {
		vmodel: "",
		label: "Type de majoration",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true
	},
	regime: {
		vmodel: "",
		label: "Régime maladie / retraite",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false
	},
	divers: {
		vmodel: "",
		label: "Divers",
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: false,
		max: 400,
		height: 229
	},
	cp: {
		vmodel: "",
		label: "CP",
		required: true,
		max: 2,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true
	},
	cc: {
		vmodel: "",
		label: "CC",
		required: true,
		max: 2,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true
	},
	bban: {
		vmodel: "",
		label: "BBAN",
		required: true,
		max: 30,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true
	},
	bic: {
		vmodel: "",
		label: "BIC",
		required: true,
		max: 11,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true
	},
	titulaire: {
		vmodel: "",
		label: "Titulaire du compte",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		max: 50
	},
	domiciliation: {
		vmodel: "",
		label: "Domiciliation",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		max: 50
	},
	nomBanque: {
		vmodel: "",
		label: "Banque",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		max: 50
	},
	dateFinCdd: {
		vmodel: "",
		label: "Date de fin prévisionnelle du CDD",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true,
		minDate: '1900-01-01',
		display: ''
	},
	motifRecours: {
		vmodel: "",
		label: "Motif du recours",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true
	},
	salarieRemplace: {
		vmodel: "",
		label: "Salarié(e) remplacé(e)",
		required: true,
		trigger: false,
		error: false,
		clear: false,
		reset: false,
		disabled: true
	}
};

export const listeSituation: KeyValue[] = [
	{
		key: "C",
		value: "Célibataire"
	},
	{
		key: "M",
		value: "Marié(e)"
	},
	{
		key: "P",
		value: "PACS"
	},
	{
		key: "D",
		value: "Divorcé(e)"
	}
];

export const listeReglement: KeyValue[] = [
	{
		key: "2",
		value: "Chèque"
	},
	{
		key: "3",
		value: "Virement"
	}
];



// WEBPACK FOOTER //
// ./src/components/entreeSalarie/entreeSalarie.model.ts